import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Validators, UntypedFormGroup, FormBuilder } from '@angular/forms';
import { ToastController, LoadingController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-multi-factor-auth',
    templateUrl: './multi-factor-auth.page.html',
    styleUrls: ['./multi-factor-auth.page.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MultiFactorAuthPage implements OnInit {

    constructor(
        public toastController: ToastController,
        private backendService: BackendService,
        public loadingController: LoadingController,
        public storage: Storage,
        public helperService: HelperService,
        private formBuilder: FormBuilder,
        private router: Router
    ) { }
    breadcrumbList = [
        {
            label: 'Multi-Factor Authentication',
            embedurl: true,
            url: '/baseapp/multi-factor-auth'
        }
    ];
    multiFactorForm: UntypedFormGroup;
    ngOnInit(): void {

        this.multiFactorForm = this.formBuilder.group({
            verificationCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
        })
        this.generateQR();
    }
    qrCode: any = {};
    generateQR() {
        this.getStorage().then((res) => {
            this.backendService.GetAPICall("generateQR", res.token).subscribe(
                (data) => {
                    this.qrCode = data;
                    //console.log(data);
                })
        })
    }
    onSubmit() {
        if (this.multiFactorForm.invalid) {
            return;
        }
        this.getStorage().then((res) => {
            let payload = {
                "secret": this.qrCode.secret,
                "code": this.multiFactorForm.value.verificationCode,
                "user_id": res.userId
            };
            this.backendService.PostAPICall("storeQR", payload, res.token).subscribe(
                (data) => {
                    // this.qrCode = data;
                    this.helperService.presentToast(data.msg, 2000);
                    this.router.navigate(['baseapp/profile']);
                    //console.log(data);
                },(error)=>{
                    this.helperService.handleError(error);
                })
            //console.log("inside submit");
        })

    }
    async getStorage() {
        let data = {
            token: await this.storage.get("token"),
            userId: await this.storage.get("id")
        }
        return data;
    }

    cancel() {
        this.router.navigate(['baseapp/profile'])
    }
    checkLength2(e, input) {
        const functionalKeys = ['Backspace', 'ArrowRight', 'ArrowLeft'];
        if (functionalKeys.indexOf(e.key) !== -1) {
            return;
        }
        const keyValue = +e.key;
        if (isNaN(keyValue)) {
            e.preventDefault();
            return;
        }
        const hasSelection = input.selectionStart !== input.selectionEnd && input.selectionStart !== null;
        let newValue;
        if (hasSelection) {
            newValue = this.replaceSelection(input, e.key)
        } else {
            newValue = input.value + keyValue.toString();
        }
        if (newValue.length > 6) {
            e.preventDefault();
        }
    }
    private replaceSelection(input, key) {
        const inputValue = input.value;
        const start = input.selectionStart;
        const end = input.selectionEnd || input.selectionStart;
        return inputValue.substring(0, start) + key + inputValue.substring(end + 1);
    }
}

